import styled from 'styled-components'
import theme from 'theme_'
import { H5 } from 'components/Typography'
import CommonButton from 'components/Button/CommonButton'

export const CreateWLANsActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 54px ${theme.spacing.base};
  gap: ${theme.spacing.md};

  @media ${theme.devices.tablet} {
    min-height: 572px;
  }
`

export const CreateWLANsActionsHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.base};
`

export const CreateWLANsActionsTitle = styled(H5)`
  font-weight: 900;
`

export const CreateWLANsActionsBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.base};
  width: 100%;
  @media ${theme.devices.tabletLandscape} {
    flex-direction: row;
    justify-content: center;
  }
`

export const CreateWLANsActionsButton = styled(CommonButton)`
  min-width: 240px;
  height: 40px;
  width: 100%;
  @media ${theme.devices.tablet} {
    width: auto;
  }
`
